/*!
 * jquery.EqualHeights Plugin (Modified) v2.0
 * http://www.filamentgroup.com/examples/equalHeights/
 * Copyright (c) 2007 Filament Group
 * Licensed under GPL (http://www.opensource.org/licenses/gpl-license.php)
 */
$.fn.equalHeights = function (px) { $(this).each(function () { var currentTallest = 0; $(this).children().each(function (i) { if ($(this).height() > currentTallest) { currentTallest = $(this).height(); } }); $(this).children().css({ "min-height": currentTallest }).addClass("equaled"); }); return this; }; $.fn.equalWidths = function (px) { $(this).each(function () { var currentWidest = 0; $(this).children().each(function (i) { if ($(this).width() > currentWidest) { currentWidest = $(this).width(); } }); $(this).children().css({ "min-width": currentWidest }).addClass("equaled"); }); return this; };

/*!
 * hoverIntent r6 // 2011.02.26 // jQuery 1.5.1+
 * <http://cherne.net/brian/resources/jquery.hoverIntent.html>
 *
 * @param  f     onMouseOver function || An object with configuration options
 * @param  g     onMouseOut function  || Nothing (use configuration options object)
 * @author   Brian Cherne brian(at)cherne(dot)net
 */
(function ($) { $.fn.hoverIntent = function (f, g) { var cfg = { sensitivity: 7, interval: 100, timeout: 0 }; cfg = $.extend(cfg, g ? { over: f, out: g } : f); var cX, cY, pX, pY; var track = function (ev) { cX = ev.pageX; cY = ev.pageY; }; var compare = function (ev, ob) { ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t); if ((Math.abs(pX - cX) + Math.abs(pY - cY)) < cfg.sensitivity) { $(ob).unbind("mousemove", track); ob.hoverIntent_s = 1; return cfg.over.apply(ob, [ev]); } else { pX = cX; pY = cY; ob.hoverIntent_t = setTimeout(function () { compare(ev, ob); }, cfg.interval); } }; var delay = function (ev, ob) { ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t); ob.hoverIntent_s = 0; return cfg.out.apply(ob, [ev]); }; var handleHover = function (e) { var ev = jQuery.extend({}, e); var ob = this; if (ob.hoverIntent_t) { ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t); } if (e.type == "mouseenter") { pX = ev.pageX; pY = ev.pageY; $(ob).bind("mousemove", track); if (ob.hoverIntent_s != 1) { ob.hoverIntent_t = setTimeout(function () { compare(ev, ob); }, cfg.interval); } } else { $(ob).unbind("mousemove", track); if (ob.hoverIntent_s == 1) { ob.hoverIntent_t = setTimeout(function () { delay(ev, ob); }, cfg.timeout); } } }; return this.bind("mouseenter", handleHover).bind("mouseleave", handleHover); }; })(jQuery);
/*!
 * jQuery.BiggerLink v2.0.1
 * http://www.ollicle.com/eg/jquery/biggerlink/
 * Copyright (c) 2009 Oonr Boermans
 * http://creativecommons.org/licenses/MIT/
 * 2009-11-22 (22 Nov 2009)
 */
(function (a) { a.fn.biggerlink = function (b) { var c = { biggerclass: "bl-bigger", hoverclass: "bl-hover", hoverclass2: "bl-hover2", clickableclass: "bl-hot", otherstriggermaster: true, follow: "auto" }; if (b) { a.extend(c, b); } a(this).filter(function () { return a("a", this).length > 0; }).addClass(c.clickableclass).css("cursor", "pointer").each(function (g) { var d = a(this).data("biggerlink", { hovered: false, focused: false, hovered2: false, focused2: false }); var e = { all: a("a", this), big: a(this), master: a("a:first", this).data("biggerlink", { status: "master" }).addClass(c.biggerclass), other: a("a", this).not(a("a:first", this)).data("biggerlink", { status: "other" }) }; a("a", this).andSelf().each(function () { var i = a.extend(a(this).data("biggerlink"), e); a(this).data("biggerlink", i); }); var h = d.attr("title"); var f = d.data("biggerlink").master.attr("title"); if (f && !h) { d.attr("title", f); } d.mouseover(function (i) { window.status = a(this).data("biggerlink").master.get(0).href; a(this).addClass(c.hoverclass); a(this).data("biggerlink").hovered = true; }).mouseout(function (i) { window.status = ""; if (!a(this).data("biggerlink").focused) { a(this).removeClass(c.hoverclass); } a(this).data("biggerlink").hovered = false; }).bind("click", function (i) { if (!a(i.target).closest("a").length) { a(this).data("biggerlink").master.trigger({ type: "click", source: "biggerlink" }); i.stopPropagation(); } }); e.all.bind("focus", function () { a(this).data("biggerlink").big.addClass(c.hoverclass); a(this).data("biggerlink").big.data("biggerlink").focused = true; }).bind("blur", function () { if (!a(this).data("biggerlink").big.data("biggerlink").hovered) { a(this).data("biggerlink").big.removeClass(c.hoverclass); } a(this).data("biggerlink").big.data("biggerlink").focused = false; }); e.master.bind("click", function (i) { if (i.source == "biggerlink") { if (c.follow === true || c.follow == "auto" && i.result !== false) { window.location = a(this).attr("href"); } else { i.stopPropagation(); } } }); if (c.otherstriggermaster) { e.other.addClass(c.biggerclass).bind("click", function (i) { a(this).data("biggerlink").master.trigger({ type: "click", source: "biggerlink" }); i.preventDefault(); i.stopPropagation(); }); } else { e.other.bind("focus", function () { a(this).data("biggerlink").big.addClass(c.hoverclass2); a(this).data("biggerlink").big.data("biggerlink").focused2 = true; }).bind("blur", function () { if (!a(this).data("biggerlink").big.data("biggerlink").hovered2) { a(this).data("biggerlink").big.removeClass(c.hoverclass2); } a(this).data("biggerlink").big.data("biggerlink").focused2 = false; }).bind("mouseover", function (i) { a(this).data("biggerlink").big.addClass(c.hoverclass2); a(this).data("biggerlink").big.data("biggerlink").hovered2 = true; i.stopPropagation(); }).bind("mouseout", function (i) { if (!a(this).data("biggerlink").big.data("biggerlink").focused2) { a(this).data("biggerlink").big.removeClass(c.hoverclass2); } a(this).data("biggerlink").big.data("biggerlink").hovered2 = false; i.stopPropagation(); }); if (!e.other.attr("title")) { e.other.attr("title", ""); } } }); return this; }; })(jQuery);
/*!
 * jquery.Example Plugin 1.4.3
 * Copyright (c) Paul Mucur (http://mucur.name), 2007-2008.
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 */
(function (a) {
    a.fn.example = function (e, g) {
        var d = a.isFunction(e), f = a.extend({}, g, { example: e }); return this.each(function () {
            var c = a(this), b = a.metadata ? a.extend({}, a.fn.example.defaults, c.metadata(), f) : a.extend({}, a.fn.example.defaults, f); if (!a.fn.example.boundClassNames[b.className]) { a(window).on('unload', function () { a("." + b.className).val(""); }); a("form").submit(function () { a(this).find("." + b.className).val(""); }); a.fn.example.boundClassNames[b.className] = true; } if (!c.attr("defaultValue") && (d || c.val() == b.example)) c.val("");
            if (c.val() == "" && this != document.activeElement) { c.addClass(b.className); c.val(d ? b.example.call(this) : b.example); } c.focus(function () { if (a(this).is("." + b.className)) { a(this).val(""); a(this).removeClass(b.className); } }); c.change(function () { a(this).is("." + b.className) && a(this).removeClass(b.className); }); c.blur(function () { if (a(this).val() == "") { a(this).addClass(b.className); a(this).val(d ? b.example.call(this) : b.example); } });
        });
    }; a.fn.example.defaults = { className: "example" }; a.fn.example.boundClassNames = [];
})(jQuery);
/*!
 * jquery.Mousewheel Plugin 3.0.4
 * Copyright (c) 2010 Brandon Aaron (http://brandonaaron.net)
 * http://www.opensource.org/licenses/mit-license.php
 */
(function (c) { var a = ["DOMMouseScroll", "mousewheel"]; c.event.special.mousewheel = { setup: function () { if (this.addEventListener) { for (var d = a.length; d;) { this.addEventListener(a[--d], b, false); } } else { this.onmousewheel = b; } }, teardown: function () { if (this.removeEventListener) { for (var d = a.length; d;) { this.removeEventListener(a[--d], b, false); } } else { this.onmousewheel = null; } } }; c.fn.extend({ mousewheel: function (d) { return d ? this.bind("mousewheel", d) : this.trigger("mousewheel"); }, unmousewheel: function (d) { return this.unbind("mousewheel", d); } }); function b(i) { var g = i || window.event, f = [].slice.call(arguments, 1), j = 0, h = true, e = 0, d = 0; i = c.event.fix(g); i.type = "mousewheel"; if (i.wheelDelta) { j = i.wheelDelta / 120; } if (i.detail) { j = -i.detail / 3; } d = j; if (g.axis !== undefined && g.axis === g.HORIZONTAL_AXIS) { d = 0; e = -1 * j; } if (g.wheelDeltaY !== undefined) { d = g.wheelDeltaY / 120; } if (g.wheelDeltaX !== undefined) { e = -1 * g.wheelDeltaX / 120; } f.unshift(i, j, e, d); return c.event.handle.apply(this, f); } })(jQuery);
/*
 * jQuery Easing v1.4.1 - http://gsgd.co.uk/sandbox/jquery/easing/
 * Open source under the BSD License.
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * https://raw.github.com/gdsmith/jquery.easing/master/LICENSE
*/
!function(n){"function"==typeof define&&define.amd?define(["jquery"],function(e){return n(e)}):"object"==typeof module&&"object"==typeof module.exports?exports=n(require("jquery")):n(jQuery)}(function(n){function e(n){var e=7.5625,t=2.75;return n<1/t?e*n*n:n<2/t?e*(n-=1.5/t)*n+.75:n<2.5/t?e*(n-=2.25/t)*n+.9375:e*(n-=2.625/t)*n+.984375}void 0!==n.easing&&(n.easing.jswing=n.easing.swing);var t=Math.pow,u=Math.sqrt,r=Math.sin,i=Math.cos,a=Math.PI,c=1.70158,o=1.525*c,s=2*a/3,f=2*a/4.5;n.extend(n.easing,{def:"easeOutQuad",swing:function(e){return n.easing[n.easing.def](e)},easeInQuad:function(n){return n*n},easeOutQuad:function(n){return 1-(1-n)*(1-n)},easeInOutQuad:function(n){return n<.5?2*n*n:1-t(-2*n+2,2)/2},easeInCubic:function(n){return n*n*n},easeOutCubic:function(n){return 1-t(1-n,3)},easeInOutCubic:function(n){return n<.5?4*n*n*n:1-t(-2*n+2,3)/2},easeInQuart:function(n){return n*n*n*n},easeOutQuart:function(n){return 1-t(1-n,4)},easeInOutQuart:function(n){return n<.5?8*n*n*n*n:1-t(-2*n+2,4)/2},easeInQuint:function(n){return n*n*n*n*n},easeOutQuint:function(n){return 1-t(1-n,5)},easeInOutQuint:function(n){return n<.5?16*n*n*n*n*n:1-t(-2*n+2,5)/2},easeInSine:function(n){return 1-i(n*a/2)},easeOutSine:function(n){return r(n*a/2)},easeInOutSine:function(n){return-(i(a*n)-1)/2},easeInExpo:function(n){return 0===n?0:t(2,10*n-10)},easeOutExpo:function(n){return 1===n?1:1-t(2,-10*n)},easeInOutExpo:function(n){return 0===n?0:1===n?1:n<.5?t(2,20*n-10)/2:(2-t(2,-20*n+10))/2},easeInCirc:function(n){return 1-u(1-t(n,2))},easeOutCirc:function(n){return u(1-t(n-1,2))},easeInOutCirc:function(n){return n<.5?(1-u(1-t(2*n,2)))/2:(u(1-t(-2*n+2,2))+1)/2},easeInElastic:function(n){return 0===n?0:1===n?1:-t(2,10*n-10)*r((10*n-10.75)*s)},easeOutElastic:function(n){return 0===n?0:1===n?1:t(2,-10*n)*r((10*n-.75)*s)+1},easeInOutElastic:function(n){return 0===n?0:1===n?1:n<.5?-(t(2,20*n-10)*r((20*n-11.125)*f))/2:t(2,-20*n+10)*r((20*n-11.125)*f)/2+1},easeInBack:function(n){return(c+1)*n*n*n-c*n*n},easeOutBack:function(n){return 1+(c+1)*t(n-1,3)+c*t(n-1,2)},easeInOutBack:function(n){return n<.5?t(2*n,2)*(7.189819*n-o)/2:(t(2*n-2,2)*((o+1)*(2*n-2)+o)+2)/2},easeInBounce:function(n){return 1-e(1-n)},easeOutBounce:e,easeInOutBounce:function(n){return n<.5?(1-e(1-2*n))/2:(1+e(2*n-1))/2}})});

/* optitrack.global.js
 *
 * Copyright (c) 2010 NaturalPoint
 */
// Create zebra stripes in tables
function addZebraStripes() {
    $(".even.stripes").children(":odd").addClass("stripe");
    $(".odd.stripes").children(":even").addClass("stripe");
}


$(function () {

    // Cookies for shopping cart - Relocted from display_cart.cgi
    $.cookie("cookiedetect", "detected", { path: "/", expires: 3650 });
    $.cookie("storename", "optitrack", { path: "/", expires: 3650 });


    // Swap out link to contact form for 'careers' e-mail address
    $("#careersAddress").html("send a note to <a href=\"mailto:careers@naturalpoint.com\">careers@naturalpoint.com</a>.");


    // Alternate sections graphics for page scanning
    $(".indepth .section:even, .study .section:even").children(".graphic").addClass("right");
    $(".indepth .section:odd, .study .section:odd").children(".graphic").addClass("left");


    // Add "Enlarge" icons/labels to applicable images
    $(".enlarge:not(.icon.enlarge)").append("<div class=\"mark\"></div>");


    // Add Play icons to video links
    $("a.video.monitor, a.video .monitor").css("display", "inline-block").append("<div class=\"play icon\"></div>");


    // Activate tabs
    $(".tabs").tabs({ fx: { opacity: "toggle" } });


    // Expand/collapse list(s)
    $(".expandable dd").hide();
    $(".expandable dt a").prepend("<span class=\"ui-icon ui-icon-triangle-1-e\"></span>");
    $(".expandable dt a").click(function () {
        var icon = $(this).find(".ui-icon");
        if (icon.hasClass("ui-icon-triangle-1-e")) {
            icon.addClass("ui-icon-triangle-1-s");
            icon.removeClass("ui-icon-triangle-1-e");
        }
        else {
            icon.addClass("ui-icon-triangle-1-e");
            icon.removeClass("ui-icon-triangle-1-s");
        }
        $(this).parent("dt").next("dd").slideToggle();
        return false;
    });


    // Expand/collapse Optional Support Form
    $("#optional-support-form").hide();
    $(".optional-trigger a").prepend("<span class=\"ui-icon ui-icon-triangle-1-e\"></span>");
    $(".optional-trigger a").click(function (e) {
        var icon = $(this).find(".ui-icon");
        if (icon.hasClass("ui-icon-triangle-1-e")) {
            icon.addClass("ui-icon-triangle-1-s");
            icon.removeClass("ui-icon-triangle-1-e");
        }
        else {
            icon.addClass("ui-icon-triangle-1-e");
            icon.removeClass("ui-icon-triangle-1-s");
        }
        $("#optional-support-form").slideToggle();
        e.preventDefault();
    });

    // Support Accordian Feature
    $("#support-docs-videos").hide();
    $("#support-compatible-software").hide();
    $("#support-compatible-products").hide();
    $("#support-tech-specs").hide();

    // Docs & Videos
    $(".optional-trigger-docs a").prepend("<span class=\"ui-icon ui-icon-triangle-1-e\"></span>");
    $(".optional-trigger-docs a").click(function (e) {
        var icon = $(this).find(".ui-icon");
        if (icon.hasClass("ui-icon-triangle-1-e")) {
            icon.addClass("ui-icon-triangle-1-s");
            icon.removeClass("ui-icon-triangle-1-e");
        }
        else {
            icon.addClass("ui-icon-triangle-1-e");
            icon.removeClass("ui-icon-triangle-1-s");
        }
        $("#support-docs-videos").slideToggle();
        e.preventDefault();
    });

    // Compatible Software
    $(".optional-trigger-software a").prepend("<span class=\"ui-icon ui-icon-triangle-1-e\"></span>");
    $(".optional-trigger-software a").click(function (e) {
        var icon = $(this).find(".ui-icon");
        if (icon.hasClass("ui-icon-triangle-1-e")) {
            icon.addClass("ui-icon-triangle-1-s");
            icon.removeClass("ui-icon-triangle-1-e");
        }
        else {
            icon.addClass("ui-icon-triangle-1-e");
            icon.removeClass("ui-icon-triangle-1-s");
        }
        $("#support-compatible-software").slideToggle();
        e.preventDefault();
    });

    // Compatible Products
    $(".optional-trigger-products a").prepend("<span class=\"ui-icon ui-icon-triangle-1-e\"></span>");
    $(".optional-trigger-products a").click(function (e) {
        var icon = $(this).find(".ui-icon");
        if (icon.hasClass("ui-icon-triangle-1-e")) {
            icon.addClass("ui-icon-triangle-1-s");
            icon.removeClass("ui-icon-triangle-1-e");
        }
        else {
            icon.addClass("ui-icon-triangle-1-e");
            icon.removeClass("ui-icon-triangle-1-s");
        }
        $("#support-compatible-products").slideToggle();
        e.preventDefault();
    });

    // Tech Specs
    $(".optional-trigger-specs a").prepend("<span class=\"ui-icon ui-icon-triangle-1-e\"></span>");
    $(".optional-trigger-specs a").click(function (e) {
        var icon = $(this).find(".ui-icon");
        if (icon.hasClass("ui-icon-triangle-1-e")) {
            icon.addClass("ui-icon-triangle-1-s");
            icon.removeClass("ui-icon-triangle-1-e");
        }
        else {
            icon.addClass("ui-icon-triangle-1-e");
            icon.removeClass("ui-icon-triangle-1-s");
        }
        $("#support-tech-specs").slideToggle();
        e.preventDefault();
    });

    // Expand/collapse size charts
    $('[class*="-chart-link"]').click(function () {
        $(this).next('[id*="-chart"]').slideToggle('slow');

        return false;
    });
    $('[id*="-chart"]').slideUp('slow');


    // Filter bar(s)
    $('.filter-bar a').not('.selected').click(function () {
        var isSelected = $(this).closest('li').hasClass('selected');
        var isMenuOpen = $('.filter-bar').hasClass('open');

        if (isSelected) {
            if (isMenuOpen) {
                $(this).closest('.filter-bar').removeClass('open').addClass('closed');
            }
            else {
                $(this).closest('.filter-bar').removeClass('closed').addClass('open');
                return false;
            }
        }
        else {
            var filterBy = $(this).closest('.filter-option').attr('id');

            $(this).closest('.filter.bar, .filter-bar').find('.selected').removeClass('selected');
            $(this).closest('li').addClass('selected');

            $('#results').fadeOut(0, function () {

                if (filterBy === 'all') {
                    $('#results .product, #results > li').each(function () {
                        $(this).show();
                        $('div.copy').hide();
                    });
                }
                else {
                    $('#results .product, #results > li').each(function () {
                        var filtered = $(this).hasClass(filterBy);
                        if (filtered) {
                            if ($(this).not(':visible')) {
                                $(this).show();
                            }
                        }
                        else {
                            $(this).hide();
                        }
                    });
                }
                $('#results').fadeIn(0);

            });

            $(this).closest('.filter-bar').removeClass('open').addClass('closed');
        }
        return false;
    });


    // Classic drop-down navigation - Use sparingly
    $("form.goto:not(.manuals) .url").change(function () {
        var beginURL = $(this).closest(".goto").attr("action");
        var endURL = $(this).find("option:selected").val();

        // Reset selection, except for IE7 and IE8
        if ($(".ie7,.ie8").length === 0) {
            $(this).val("");
        }

        // Test to see if the current selection has a URL value
        if (endURL === "") {
            return false;
        }
        else {
            // Is there a base URL in the action attribute to pull from?
            if (endURL.match(/http/)) {
                window.location = endURL;
            }
            else {
                window.location = beginURL + endURL;
            }
        }
    });

    // Document selection behavior
    var documentsList = "form.goto.manuals .url";

    function updateDocumentLink(elem) {
        var beginURL = $(elem).closest(".goto").attr("action");
        var endURL = $(elem).find("option:selected").val();

        // Test to see if the current selection has a URL value
        if (endURL === "") {
            $(elem).parent("fieldset").next("#documentURL").fadeOut();
        }
        else {
            $(elem).parent("fieldset").next("#documentURL").attr("href", beginURL + endURL).fadeIn();
        }
    }

    updateDocumentLink(documentsList);

    $(documentsList).change(function () {
        updateDocumentLink(this);
    });

    $(documentsList).keyup(function () {
        updateDocumentLink(this);
    });


    // Activate contact form validation
    $("form#contactForm").validate();


    // ***********************************************************************
    // License Query Begin
    // ***********************************************************************

    var regStatus = $.getUrlVar("reg_status");
    var prodHash = $.getUrlVar("prod_hash");
    var regSerial = $.getUrlVar("reg_serial");

    if (typeof regSerial === "undefined") {
        regSerial = $.getUrlVar("r_e_g_serial");
    }


    // Show example text in license query form(s)
    function showExamples() {
        $("#licenseQuery input#prod_serial").example("ABC1234");
        $("#licenseQuery input#prod_hash").example("ABCD-1234-EFGH-IJKL");
        $("#licenseQuery input#reg_serial").example("123456");

        if ((typeof regSerial === "undefined") && (typeof prodHash === "undefined")) {
            $("#check_reg_serial").example("123456");
            $("#check_prod_hash").example("ABCD-1234-EFGH-IJKL");
        }
    }

    // Enable submit buttons when the license query form is completely filled in
    function isFormComplete(element) {
        var inputExamples = $(element + " input").hasClass("example");
        var inputsEmpty;

        $(element + " input").each(function () {
            if ($(this).val().length === 0) {
                inputsEmpty = false;
                return false;
            }
            else { inputsEmpty = true; }
        });

        if (!inputExamples && inputsEmpty) {
            $(element + " button[type=submit]").prop("disabled", false);
        } else {
            $(element + " button[type=submit]").prop("disabled", true);
        }
    }

    //Watch licesnse query form
    function watchForm(element) {
        $(element).on("keypress", function () {
            isFormComplete(element);
        });

        $(element).find("input").on("blur", function () {
            isFormComplete(element);
        });
    }
    // Setup license query
    function licenseQuerySetup() {
        if ($("#licenseQuery").length > 0) {
            var resultRegEx = /(.+\?)(.+)/;
            var pageUrl = location.href;
            var resultStr = pageUrl.replace(resultRegEx, "$2");

            // Initialize license query accordion
            $("#licenseQuery").accordion({ navigation: true });

            // Disabled License Query submit buttons
            $("#licenseQuery form button[type=submit]").attr("disabled", "disabled");

            // Show input hints/examples
            showExamples();

            // "Activate My License"
            var activateForm = "#licenseQuery .activate form";
            var activateUrl = "/support/activate/activate_license.cgi";
            var activateResultUrl = "/support/activate/activate_result.cgi";

            watchForm("#activateForm");

            // Submit activation info and return result
            $(activateForm).on("submit", function () {
                $(".activate .results").hide();
                $(".activate .info:not(.help)").fadeOut("slow").promise().done(function () {
                    var form = $("#activateForm").serialize();
                    $.ajax({
                        url: activateUrl,
                        data: form,
                        success: function (regStatus) {
                            if (typeof regStatus != "undefined") {
                                $.ajax({
                                    url: activateResultUrl,
                                    data: regStatus,
                                    success: function (html) {
                                        $(".activate .results").html(html);
                                        $(".activate .results").fadeIn("slow").promise().done(function () {
                                            $("#activateAgain").click(function () {
                                                $(".activate .results").fadeOut("slow").promise().done(function () {
                                                    $(".activate .info:not(.help)").fadeIn("slow");
                                                });
                                            });
                                        });
                                    }
                                });
                            }
                        }
                    });
                });
                return false;
            });

            // "Check My License"
            var checkForm = "#licenseQuery .check form:not(form.renew)";
            var checkUrl = "/support/activate/license_query.cgi";

            watchForm("#checkForm");

            $(checkForm).on("submit", function () {
                $(".check .results").hide();
                $(".check .info:not(.help)").fadeOut("slow").promise().done(function () {
                    var form = $("#checkForm").serialize();
                    $.ajax({
                        support_form: true,
                        url: checkUrl,
                        data: form,
                        success: function (result) {
                            $(".check .results").html(result);
                            $(".check .results").fadeIn("slow").promise().done(function () {
                                $("#checkAgain").click(function () {
                                    $(".check .results").fadeOut("slow").promise().done(function () {
                                        $(".check .info:not(.help)").fadeIn("slow");
                                    });
                                });
                            });
                        }
                    });
                });
                return false;
            });



            // Handle license check search links from admin
            if ((typeof regSerial != "undefined") && (typeof prodHash != "undefined")) {
                $("#checkLicense").click();
                $("#check_reg_serial").val(regSerial);
                $("#check_prod_hash").val(prodHash);
                $("#checkLicense + .check form").submit();
            }
        }
    }

    // Initialize "help" panel behaviour
    $("#licenseQuery img.help").on("click", function () {
        $(this).parent().next().find(".help.info").slideToggle();
    });

    // Dynamically load license query on non-support pages and overwrite link redirect
    $("a.check.license:not(.noajax)").click(function () {
        if ($("#licenseQuery").length < 1) {
            var loadUrl = $(this).attr("href");

            $(this).parent().after("<div id=\"licensePanel\"></div>");
            $("#licensePanel").load(loadUrl + " #licenseQuery", function (settings) {
                licenseQuerySetup();
                $("#licensePanel").slideDown(function () {
                    $("#checkLicense").click();
                });
            });
        }
        return false;
    });

    // ***********************************************************************
    // License Query End
    // ***********************************************************************

    // Automatically expands select dropdowns
    function expandSelectDropdowns() {
        var icon = $(".autoExpandTrigger").find(".ui-icon");
        if (icon.hasClass("ui-icon-triangle-1-e")) {
            icon.addClass("ui-icon-triangle-1-s");
            icon.removeClass("ui-icon-triangle-1-e");
        }
        else {
            icon.addClass("ui-icon-triangle-1-e");
            icon.removeClass("ui-icon-triangle-1-s");
        }
        $(".autoExpandTrigger").parent("dt").next("dd").slideToggle();
    }

    /* Adds classes name after the current date to the body */
    function assignDateClasses() {
        var dateObj = new Date();
        var month = dateObj.getMonth() + 1; //months from 1-12
        var date = dateObj.getDate();
        var year = dateObj.getFullYear();

        document.body.classList.add("date-"+date);
        document.body.classList.add("month-"+month);
        document.body.classList.add("year-"+year);

    }


    // When window is loaded...
    $(window).on('load', function () {
        /* Get the URL */
        var whereFrom = window.location.href;
        var whereFromParam = '';
        var whereFromHash = '';

        // Show labels in Newsletter text fields
        $(".newsletter input#name").example("Name");
        $(".newsletter input#utkllr-utkllr").example("Email");

        /* Check if parameters exists in the url */
        if(whereFrom.indexOf("?") !== -1) {
            whereFromParam = whereFrom.substr(whereFrom.lastIndexOf("?") + 1);
        }

        /* Check if hash exists in the url */
        if(whereFrom.indexOf("#") !== -1) {
            whereFromHash = whereFrom.substr(whereFrom.lastIndexOf("#") + 1);
        }

        // Auto expand dropdown.
        // if from Motive Software News
        if (whereFromParam === "autoExpand") {
            expandSelectDropdowns();
        }

        /* If there is a hash in the url scroll to it */
        if(whereFromHash.length > 0 && document.getElementById(whereFromHash)) {
            $("html, body").animate({
                scrollTop: $("#" + whereFromHash).offset().top
            }, 750);
        }

        // Quick fix for jump bar in IE7
        $(".ie7 .utilities .breadcrumbs .parent").append("<div style=\"display: block\" title=\"IE7 Fix to prevent jump bar items jumping around.\"></div>");


        // Expand list(s) when linked directly
        var pageURL = unescape(window.location.href);
        var beginID = pageURL.indexOf("#");
        var endID = pageURL.indexOf("?");
        var linkID = 0;

        if (beginID > 0 && endID < 0) {
            linkID = pageURL.slice(beginID);
        }
        else if (beginID > 0 && endID > 0) {
            linkID = pageURL.slice(beginID, endID);
        }

        if ($("body#systems").length <= 0 && linkID.length > 0) {
            $(linkID).click();
        }


        // Apply zebra stripes
        addZebraStripes();


        // Make the following children equal height or width
        $(".equal").equalHeights(true);


        // Extend elements to the same height as their parent container
        $(".extend").each(function () {
            var parentHeight = $(this).parent().height();
            $(this).height(parentHeight);
        });


        // Convert qualifying images into shaded ones
        $(".shade img").not(".bezel img").each(function () {

            var imgSrc = $(this).attr("src");
            var imgWidth = $(this).width();
            var imgHeight = $(this).height();

            // Images in a hidden container have no dimensions
            if (imgWidth === 0) {
                var imgWidth = $(this).attr("width");
            }
            if (imgHeight === 0) {
                var imgHeight = $(this).attr("height");
            }

            $(this).parent(".shade").css({
                "width": imgWidth,
                "height": imgHeight,
                "background-image": "url(" + imgSrc + ")"
            });
            // Hide original image if not IE
            if (!(jQuery.browser.msie)) {
                $(this).hide();
            }
            else { return false; }
        });


        // Make big links
        $(".biglink").biggerlink();


        // Setup license query
        if ($("#licenseQuery").length > 0) {
            licenseQuerySetup();
        }

        /* Assigns classes to the body based on the current date */
        assignDateClasses();


    });

    // Fix for restricted width select field in IE on XP
    var downloadDocumentsWidth = $("select#downloadDocuments").css("width");

    $(".ie7 select#downloadDocuments, .ie8 select#downloadDocuments").focus(function () {
        $(this).css("width", "auto");
    }).blur(function () {
        $(this).css("width", downloadDocumentsWidth);
    });

});
